/* Khat Mitthi D2C theme interactions — vanilla JS, no frameworks.
   Works with Horizon's cart drawer (#cart-drawer) and search modal (#search-modal). */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- header ---------- */
  const header = $('.km-header');
  const onScroll = () => header && header.classList.toggle('is-scrolled', scrollY > 8);
  addEventListener('scroll', onScroll, { passive: true }); onScroll();
  const hg = $('#header-group');
  const setMarqueeH = () => { const m = $('.km-marquee', hg || document); document.documentElement.style.setProperty('--km-marquee-h', (m ? m.offsetHeight : 0) + 'px'); };
  if (hg) { setMarqueeH(); addEventListener('resize', setMarqueeH); if (header && !header.classList.contains('is-sticky')) hg.classList.add('km-not-sticky'); }

  function openCartDrawer() {
    const d = $('#cart-drawer');
    if (!d) return false;
    try {
      if (typeof d.open === 'function') d.open();
      else if (typeof d.showDialog === 'function') d.showDialog();
      else if (typeof d.toggle === 'function') d.toggle();
      else return false;
      return true;
    } catch (e) { return false; }
  }
  $$('[data-km-cart]').forEach(b => b.addEventListener('click', e => {
    if (openCartDrawer()) e.preventDefault();
  }));
  $$('[data-km-search]').forEach(b => b.addEventListener('click', e => {
    const m = $('#search-modal');
    if (m && typeof m.showDialog === 'function') { e.preventDefault(); m.showDialog(); }
  }));

  const setCount = n => $$('[data-km-count]').forEach(el => { el.textContent = n; el.dataset.count = n; });
  const refreshCount = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(c => setCount(c.item_count)).catch(() => {});
  document.addEventListener('cart:update', refreshCount);
  document.addEventListener('km:cart', refreshCount);

  /* mobile menu */
  const burger = $('.km-burger');
  if (burger) burger.addEventListener('click', () => {
    let m = $('#km-mobile');
    if (m) { m.remove(); burger.setAttribute('aria-expanded', 'false'); return; }
    m = document.createElement('nav'); m.id = 'km-mobile'; m.className = 'km-scope'; m.setAttribute('aria-label', 'Mobile menu');
    m.innerHTML = $$('.km-nav a').map(a => `<a href="${a.getAttribute('href')}">${a.textContent}</a>`).join('');
    document.body.appendChild(m); burger.setAttribute('aria-expanded', 'true');
  });

  /* ---------- reveals ---------- */
  const reveal = $$('.km-card, .km-tile, .km-value, .km-combo, .km-post, .km-review, .km-faq, .km-sec__head, .km-story__copy, .km-cta-band');
  reveal.forEach((el, i) => { el.classList.add('km-reveal'); el.style.transitionDelay = ((i % 4) * 70) + 'ms'; });
  if ('IntersectionObserver' in window && !reduced) {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveal.forEach(el => io.observe(el));
  } else reveal.forEach(el => el.classList.add('is-in'));
  const hero = $('.km-hero'); if (hero) requestAnimationFrame(() => hero.classList.add('is-in'));
  // theme editor: reveal anything re-rendered
  document.addEventListener('shopify:section:load', e => $$('.km-reveal', e.target).forEach(el => el.classList.add('is-in')));

  /* story parallax */
  const par = $('.km-parallax img');
  if (par && !reduced) {
    let t; const run = () => { const r = par.parentElement.getBoundingClientRect(); const p = Math.max(-0.6, Math.min(0.6, (r.top + r.height / 2 - innerHeight / 2) / innerHeight)); par.style.transform = `translateY(${(-p * 7).toFixed(2)}%)`; t = null; };
    addEventListener('scroll', () => { if (!t) t = requestAnimationFrame(run); }, { passive: true }); run();
  }

  /* ---------- type filter chips (product grid) ---------- */
  $$('[data-km-filter-grid]').forEach(sec => {
    const grid = $('.km-grid', sec);
    $$('.km-chips [data-filter]', sec).forEach(chip => chip.addEventListener('click', () => {
      $$('.km-chips [data-filter]', sec).forEach(c => c.classList.toggle('is-on', c === chip));
      const f = chip.dataset.filter;
      $$('.km-card', grid).forEach(card => {
        const show = f === 'all' || card.dataset.type === f;
        card.classList.toggle('is-hide', !show); card.classList.remove('is-pop');
        if (show) { void card.offsetWidth; card.classList.add('is-pop', 'is-in'); }
      });
    }));
  });

  /* ---------- toast ---------- */
  let toast = $('#km-toast');
  if (!toast) { toast = document.createElement('div'); toast.id = 'km-toast'; toast.className = 'km-toast km-scope'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
  const say = m => { toast.textContent = m; toast.classList.add('is-on'); clearTimeout(toast._t); toast._t = setTimeout(() => toast.classList.remove('is-on'), 2200); };

  /* ---------- add to cart (real) ---------- */
  async function addToCart(id, qty, sellingPlan) {
    const body = { items: [{ id: Number(id), quantity: qty || 1 }], sections: 'cart-drawer-section' };
    if (sellingPlan) body.items[0].selling_plan = Number(sellingPlan);
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
    // refresh Horizon's cart drawer markup
    const wrap = $('#shopify-section-cart-drawer-section');
    if (wrap && data.sections && data.sections['cart-drawer-section']) {
      const tmp = document.createElement('div'); tmp.innerHTML = data.sections['cart-drawer-section'];
      const inner = tmp.firstElementChild;
      wrap.innerHTML = inner && inner.id === 'shopify-section-cart-drawer-section' ? inner.innerHTML : tmp.innerHTML;
    }
    document.dispatchEvent(new CustomEvent('km:cart', { detail: data }));
    document.dispatchEvent(new CustomEvent('cart:add', { detail: { id, qty } }));
    $$('.km-cart').forEach(c => { c.classList.add('is-bump'); setTimeout(() => c.classList.remove('is-bump'), 300); });
    if (!openCartDrawer()) say('Added to cart');
    return data;
  }

  // card quick add (single-variant products)
  $$('[data-km-quick-add]').forEach(b => b.addEventListener('click', async () => {
    b.disabled = true; const t = b.textContent; b.textContent = 'Adding…';
    try { await addToCart(b.dataset.kmQuickAdd, 1); } catch (e) { say(e.message); }
    b.disabled = false; b.textContent = t;
  }));

  /* ---------- PDP ---------- */
  const pdp = $('.km-pdp');
  if (pdp) {
    const variants = JSON.parse(($('#km-variants') || { textContent: '[]' }).textContent);
    const form = $('form.km-buy-form', pdp);
    const idInput = form && $('input[name="id"]', form);
    const qtyInput = $('.km-qty input', pdp);
    const priceEl = $('#km-price'), stickyPrice = $('#km-sticky-price');
    const addBtn = $('[data-km-add]', pdp), buyBtn = $('[data-km-buy]', pdp), stickyBtn = $('[data-km-sticky-add]');
    const mainImg = $('#km-main-img');
    const money = c => (window.KM_MONEY_FORMAT || '₹{{amount_no_decimals}}').replace(/Rs\.\s?/,'₹').replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100).toLocaleString('en-IN')).replace(/\{\{\s*amount\s*\}\}/, c % 100 === 0 ? (c / 100).toLocaleString('en-IN') : (c / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 }));
    const current = () => variants.find(v => String(v.id) === String(idInput && idInput.value)) || variants[0];

    function sync() {
      const v = current(); if (!v) return;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      const cmp = $('#km-compare'); if (cmp) { if (v.compare_at_price > v.price) { cmp.textContent = money(v.compare_at_price); cmp.hidden = false; } else cmp.hidden = true; }
      [addBtn, stickyBtn].forEach(b => { if (!b) return; b.disabled = !v.available; b.textContent = v.available ? (b.dataset.label || 'Add to cart') : 'Sold out'; });
      if (buyBtn) buyBtn.href = `/cart/${v.id}:${Math.max(1, parseInt(qtyInput && qtyInput.value) || 1)}`;
      if (v.featured_image && mainImg && mainImg.dataset.variantSwap !== 'off') {
        const t = $$('.km-thumb').find(t => t.dataset.mediaId && String(t.dataset.mediaId) === String(v.featured_media && v.featured_media.id));
        if (t) t.click();
      }
      if (history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    $$('.km-var input', pdp).forEach(r => r.addEventListener('change', () => { if (idInput) idInput.value = r.value; sync(); }));
    $$('.km-var-select', pdp).forEach(sel => sel.addEventListener('change', () => { if (idInput) idInput.value = sel.value; sync(); }));
    $$('.km-qty [data-q]', pdp).forEach(b => b.addEventListener('click', () => { qtyInput.value = Math.max(1, (parseInt(qtyInput.value) || 1) + parseInt(b.dataset.q)); sync(); }));
    if (qtyInput) qtyInput.addEventListener('change', sync);
    const doAdd = async btn => {
      const v = current(); if (!v) return;
      btn.disabled = true; const t = btn.textContent; btn.textContent = 'Adding…';
      const sp = $('input[name="selling_plan"]:checked', pdp);
      try { await addToCart(v.id, Math.max(1, parseInt(qtyInput && qtyInput.value) || 1), sp && sp.value); } catch (e) { say(e.message); }
      btn.disabled = false; btn.textContent = t;
    };
    if (form) form.addEventListener('submit', e => { e.preventDefault(); doAdd(addBtn); });
    if (stickyBtn) stickyBtn.addEventListener('click', () => doAdd(stickyBtn));
    // gallery
    $$('.km-thumb').forEach(t => t.addEventListener('click', () => {
      $$('.km-thumb').forEach(x => x.classList.toggle('is-on', x === t));
      if (!mainImg) return; mainImg.style.opacity = 0;
      setTimeout(() => { mainImg.src = t.dataset.src; if (t.dataset.srcset) mainImg.srcset = t.dataset.srcset; mainImg.alt = t.dataset.alt || mainImg.alt; mainImg.onload = () => mainImg.style.opacity = 1; }, 150);
    }));
    // sticky bar
    const sticky = $('#km-sticky');
    if (sticky && addBtn) {
      const updSticky = () => { const r = addBtn.getBoundingClientRect(); sticky.classList.toggle('is-on', r.bottom < 0); };
      window.__kmStickyIO = 'IntersectionObserver' in window ? new IntersectionObserver(updSticky, { threshold: [0, 1] }) : null;
      if (window.__kmStickyIO) window.__kmStickyIO.observe(addBtn);
      [window, document.querySelector('.page-wrapper')].forEach(el => el && el.addEventListener('scroll', updSticky, { passive: true }));
      updSticky();
    }
    // subscribe toggle
    const subBox = $('.km-sub input[type=checkbox]', pdp);
    if (subBox) subBox.addEventListener('change', () => { const sp = $('input[name="selling_plan"]', pdp); if (sp) sp.disabled = !subBox.checked; });
    sync();
  }

  /* ---------- collection ---------- */
  $$('[data-km-sort]').forEach(sel => sel.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u; }));
  $$('[data-km-seo-visible]').forEach(body => {
    const n = parseInt(body.dataset.kmSeoVisible || '3', 10);
    const more = $('.km-seo__toggle', body);
    const kids = [...body.children].filter(el => el !== more && el.tagName !== 'SCRIPT');
    if (kids.length <= n || !more) return;
    const extra = kids.slice(n); extra.forEach(el => { el.classList.add('km-seo__more'); el.hidden = true; }); more.hidden = false;
    more.addEventListener('click', () => {
      const opening = extra[0].hidden; extra.forEach(el => { el.hidden = !opening; });
      more.innerHTML = (opening ? more.dataset.less : more.dataset.more) + ' <span>' + (opening ? '↑' : '→') + '</span>';
    });
  });

  /* ---------- related products (Section Rendering) ---------- */
  $$('[data-km-recommendations]').forEach(sec => {
    const url = sec.dataset.kmRecommendations; if (!url) return;
    fetch(url).then(r => r.text()).then(html => {
      const tmp = document.createElement('div'); tmp.innerHTML = html;
      const fresh = tmp.querySelector('[data-km-recommendations]');
      if (fresh && fresh.querySelector('.km-card')) { sec.innerHTML = fresh.innerHTML; $$('.km-reveal, .km-card', sec).forEach(el => el.classList.add('is-in')); }
    }).catch(() => {});
  });
})();
